export default __webpack_public_path__ + "static/media/email-icon.e3703a3b.svg";